module.exports = __webpack_public_path__ + "img/pt.ada259b5.svg";